//@flow
import * as Immutable from 'immutable';

import { ZoneMapFolder } from 'common/models/flow/ZoneMapFolder';
import type { ZoneMapFolderModelType } from 'common/models/flow/ZoneMapFolder';
import { ZoneMapGeometryStatusEnum } from 'common/enums/ZoneMapGeometryStatus';

type ZoneMapFolderInternalStatusEnum = 'HIDDEN' | 'NEW';

class InternalZoneMapFolder extends ZoneMapFolder {
    static fromJS(json: ZoneMapFolderModelType): InternalZoneMapFolder {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    setInternalStatus(
        status: ZoneMapFolderInternalStatusEnum
    ): InternalZoneMapFolder {
        return this.clone(this._state.set('internalStatus', status));
    }

    getInternalStatus(): ZoneMapFolderInternalStatusEnum {
        return this._state.get('internalStatus');
    }

    isHidden(): boolean {
        return this.getInternalStatus()
            ? this.getInternalStatus() === ZoneMapGeometryStatusEnum.Hidden
            : false;
    }
}

export { InternalZoneMapFolder as ZoneMapFolder };
